module.exports = __webpack_public_path__ + "img/root000.09a41ef6.png";